/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class AlternateProductGallery extends HTMLElement {
    constructor() {
      super();

      this.initialized = false;
      this.buttons = false;
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.onButtonArrowClick = (e) => this.buttonArrowClickEvent(e);
      this.container = this.closest('[data-section-type="product"]');
      this.handleMouseDown = this.handleMouseDown.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleMouseUp = this.handleMouseUp.bind(this);
      this.handleMouseMove = this.handleMouseMove.bind(this);
      this.handleKeyUp = this.handleKeyUp.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.productMediaItems = this.querySelectorAll('[data-slide]');
      this.productMediaList = this.querySelector('[data-product-media-list]');
      this.setHeight = this.setHeight.bind(this);
      this.toggleEvents = this.toggleEvents.bind(this);
      this.selectMediaEvent = (e) => this.showMediaOnVariantSelect(e);
      this.useCustomImages = this.hasAttribute('data-custom-images');
    }

    connectedCallback() {
      this.productMediaObserver();
      this.toggleEvents();
      this.listen();
      this.setHeight();
    }

    disconnectedCallback() {
      this.removeEventListener('theme:resize:width', this.toggleEvents);
      this.removeEventListener('theme:resize:width', this.setHeight);
      this.removeEventListener('theme:media:select', this.selectMediaEvent);
      window.removeEventListener('resize', this.handleResize);
      this.removeArrows();
    }

    listen() {
      document.addEventListener('theme:resize:width', this.toggleEvents);
      document.addEventListener('theme:resize:width', this.setHeight);
      this.addEventListener('theme:media:select', this.selectMediaEvent);
      
      // Add resize listener for arrow visibility
      window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
      const isDesktop = window.innerWidth >= 990;
      
      if (isDesktop && !this.buttons) {
        this.initArrows();
      } else if (!isDesktop && this.buttons) {
        this.removeArrows();
      }
    }

    toggleEvents() {
      const isDesktop = window.innerWidth >= 990;
      const isMobile = window.innerWidth < 990;

      if (isDesktop && this.hasAttribute('data-fader-desktop')) {
        this.addFaderEvents();
        this.initArrows();
      } else if (isMobile && this.hasAttribute('data-fader-mobile')) {
        this.addFaderEvents();
        this.removeArrows();
      } else {
        this.removeFaderEvents();
        this.removeArrows();
      }
    }

    addFaderEvents() {
      if (this.initialized) return;

      this.initialized = true;
      this.productMediaList.addEventListener('mousedown', this.handleMouseDown);
      this.productMediaList.addEventListener('mouseleave', this.handleMouseLeave);
      this.productMediaList.addEventListener('mouseup', this.handleMouseUp);
      this.productMediaList.addEventListener('mousemove', this.handleMouseMove);
      this.productMediaList.addEventListener('keyup', this.handleKeyUp);
      
      // Add touch events for mobile swiping
      this.productMediaList.addEventListener('touchstart', this.handleTouchStart, { passive: false });
      this.productMediaList.addEventListener('touchmove', this.handleTouchMove, { passive: false });
      this.productMediaList.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    }

    removeFaderEvents() {
      if (!this.initialized) return;

      this.initialized = false;
      this.productMediaList.removeEventListener('mousedown', this.handleMouseDown);
      this.productMediaList.removeEventListener('mouseleave', this.handleMouseLeave);
      this.productMediaList.removeEventListener('mouseup', this.handleMouseUp);
      this.productMediaList.removeEventListener('mousemove', this.handleMouseMove);
      this.productMediaList.removeEventListener('keyup', this.handleKeyUp);
      
      // Remove touch events
      this.productMediaList.removeEventListener('touchstart', this.handleTouchStart);
      this.productMediaList.removeEventListener('touchmove', this.handleTouchMove);
      this.productMediaList.removeEventListener('touchend', this.handleTouchEnd);
    }

    handleMouseDown(e) {
      this.isDown = true;
      this.productMediaList.style.cursor = 'grabbing';
      this.startX = e.pageX - this.productMediaList.offsetLeft;
      this.scrollLeft = this.productMediaList.scrollLeft;
    }

    handleMouseLeave() {
      this.isDown = false;
      this.productMediaList.style.cursor = 'grab';
    }

    handleMouseUp(e) {
      if (!this.isDown) return;
      
      this.isDown = false;
      this.productMediaList.style.cursor = 'grab';
      
      // Calculate the drag distance
      const endX = e.pageX - this.productMediaList.offsetLeft;
      const diffX = this.startX - endX;
      
      // Check if the drag was significant enough to change images
      if (Math.abs(diffX) > 50) {
        if (diffX > 0) {
          // Dragged left - show next image
          this.showNextImage();
        } else {
          // Dragged right - show previous image
          this.showPreviousImage();
        }
      }
    }

    handleMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      // Don't actually scroll the container since images are positioned absolutely
      // Just track the movement for the mouse up event
    }

    handleTouchStart(e) {
      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (!this.touchStartX || !this.touchStartY) return;
      
      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (!this.touchStartX || !this.touchStartY) return;
      
      const diffX = this.touchStartX - this.touchEndX;
      const diffY = this.touchStartY - this.touchEndY;
      
      // Check if the swipe was horizontal and significant enough
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        if (diffX > 0) {
          // Swiped left - show next image
          this.showNextImage();
        } else {
          // Swiped right - show previous image
          this.showPreviousImage();
        }
      }
      
      // Reset touch coordinates
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
    }

    handleKeyUp(e) {
      if (e.key === 'ArrowLeft') {
        this.showPreviousImage();
      } else if (e.key === 'ArrowRight') {
        this.showNextImage();
      }
    }

    buttonArrowClickEvent(e) {
      e.preventDefault();
      const direction = e.currentTarget.getAttribute('data-direction');
      
      if (direction === 'next') {
        this.showNextImage();
      } else if (direction === 'prev') {
        this.showPreviousImage();
      }
    }

    initArrows() {
      // Only show arrows on desktop
      if (window.innerWidth < 990) return;
      
      if (this.buttons) return;
      
      this.buttons = true;
      
      // Create arrow container
      const arrowContainer = document.createElement('div');
      arrowContainer.className = 'slider__arrows';
      arrowContainer.style.cssText = `
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        transform: translateY(-50%);
        z-index: 10;
        pointer-events: none;
      `;
      
      // Create previous button
      const prevButton = document.createElement('button');
      prevButton.className = 'slider__button slider__button--prev';
      prevButton.setAttribute('data-direction', 'prev');
      prevButton.setAttribute('aria-label', 'Previous image');
      prevButton.style.cssText = `
        position: absolute;
        left: 20px;
        top: 61%;
        transform: translateY(-50%);
        width: 44px;
        height: 44px;
        border: none;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.9);
        color: #000;
        cursor: pointer;
        pointer-events: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        transition: all 0.2s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      `;
      prevButton.innerHTML = ' ';
      prevButton.addEventListener('click', this.onButtonArrowClick);
      
      // Create next button
      const nextButton = document.createElement('button');
      nextButton.className = 'slider__button slider__button--next';
      nextButton.setAttribute('data-direction', 'next');
      nextButton.setAttribute('aria-label', 'Next image');
      nextButton.style.cssText = `
        position: absolute;
        right: 20px;
        top: 61%;
        transform: translateY(-50%);
        width: 44px;
        height: 44px;
        border: none;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.9);
        color: #000;
        cursor: pointer;
        pointer-events: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        transition: all 0.2s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      `;
      nextButton.innerHTML = ' ';
      nextButton.addEventListener('click', this.onButtonArrowClick);
      
      // Add hover effects
      [prevButton, nextButton].forEach(button => {
        button.addEventListener('mouseenter', () => {
          button.style.background = 'rgba(255, 255, 255, 1)';
          button.style.transform = 'translateY(-50%) scale(1.1)';
        });
        button.addEventListener('mouseleave', () => {
          button.style.background = 'rgba(255, 255, 255, 0.9)';
          button.style.transform = 'translateY(-50%) scale(1)';
        });
      });
      
      arrowContainer.appendChild(prevButton);
      arrowContainer.appendChild(nextButton);
      this.productMediaList.appendChild(arrowContainer);
      
      // Store references for cleanup
      this.arrowContainer = arrowContainer;
      this.prevButton = prevButton;
      this.nextButton = nextButton;
    }

    removeArrows() {
      if (!this.buttons) return;
      
      if (this.prevButton) {
        this.prevButton.removeEventListener('click', this.onButtonArrowClick);
      }
      if (this.nextButton) {
        this.nextButton.removeEventListener('click', this.onButtonArrowClick);
      }
      
      if (this.arrowContainer) {
        this.arrowContainer.remove();
      }
      
      this.buttons = false;
      this.arrowContainer = null;
      this.prevButton = null;
      this.nextButton = null;
    }

    selectMedia(id) {
      if (!id) return;

      this.setActiveMedia(id);
      this.resetScrollPosition();
      this.preloadImage(id);

      // Dispatch event for other components to listen to
      this.dispatchEvent(new CustomEvent('theme:media:select', {
        detail: { id: id }
      }));
    }

    resetScrollPosition() {
      this.productMediaList.scrollLeft = 0;
    }

    preloadImage(id) {
      this.querySelector(`[data-media-id="${id}"] img`)?.setAttribute('loading', 'eager');
    }

    showMediaOnVariantSelect(e) {
      const id = e.detail.id;
      this.setActiveMedia(id);
    }

    getCurrentMedia() {
      return this.querySelector('[data-slide].media--active');
    }

    getNextMediaId() {
      const currentMedia = this.getCurrentMedia();
      const nextMedia = currentMedia?.nextElementSibling?.hasAttribute('data-media-id') ? currentMedia?.nextElementSibling : this.querySelector('[data-slide]');

      return nextMedia?.getAttribute('data-media-id');
    }

    getPreviousMediaId() {
      const currentMedia = this.getCurrentMedia();
      const lastIndex = this.productMediaItems.length - 1;
      const previousMedia = currentMedia?.previousElementSibling || this.productMediaItems[lastIndex];

      return previousMedia?.getAttribute('data-media-id');
    }

    showNextImage() {
      const id = this.getNextMediaId();
      this.selectMedia(id);
    }

    showPreviousImage() {
      const id = this.getPreviousMediaId();
      this.selectMedia(id);
    }

    setActiveMedia(id) {
      if (!id) return;

      this.setAttribute('data-active-media', id);

      const activeImage = this.querySelector('[data-slide].media--active');
      const selectedImage = this.querySelector(`[data-media-id="${id}"]`);
      const selectedImageFocus = selectedImage?.querySelector('[tabindex="0"]');

      activeImage?.classList.add('media--hiding');
      activeImage?.classList.remove('media--active');

      selectedImage?.classList.remove('media--hiding', 'media--hidden');
      selectedImage?.classList.add('media--active');

      requestAnimationFrame(() => {
        this.setHeight();

        // Move focus to the selected media
        selectedImageFocus?.focus();
      });
    }

    // Set current product image height variable to product images container
    setHeight() {
      const mediaHeight = this.querySelector('[data-slide].media--active')?.offsetHeight || this.productMediaItems[0]?.offsetHeight;
      this.style.setProperty('--height', `${mediaHeight}px`);
    }

    productMediaObserver() {
      this.productMediaItems.forEach((media) => {
        media.addEventListener('transitionend', (e) => {
          if (e.target == media && media.classList.contains('media--hiding')) {
            media.classList.remove('media--hiding');
            media.classList.add('media--hidden');
          }
        });
        media.addEventListener('transitioncancel', (e) => {
          if (e.target == media && media.classList.contains('media--hiding')) {
            media.classList.remove('media--hiding');
            media.classList.add('media--hidden');
          }
        });
      });
    }
  }

  // Custom element specifically for alternate gallery thumbnails
  class AlternateProductThumbs extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest('[data-section-type="product"]');
      this.productImagesContainer = this.container.querySelector('alternate-product-gallery');
      this.thumbSlider = this.querySelector('[data-thumbs-slider]');
      this.thumbLinks = this.querySelectorAll('[data-thumb-link]');
    }

    connectedCallback() {
      this.handleEvents();
      this.preloadImagesOnHover();
      this.activeMediaObserver();
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    activeMediaObserver() {
      const config = {attributes: true, childList: false, subtree: false};

      const callback = (mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-active-media') {
            this.setActiveThumb();
          }
        }
      };

      this.observer = new MutationObserver(callback);
      this.observer.observe(this.productImagesContainer, config);
    }

    handleEvents() {
      this.thumbLinks.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const thumbItem = thumb.closest('[data-thumb-item]');
          const id = thumb.getAttribute('data-media-id');

          if (thumbItem.classList.contains('is-active')) return;

          this.dispatchEvent(
            new CustomEvent('theme:media:select', {
              bubbles: true,
              detail: {
                id: id,
              },
            })
          );
        });
      });
    }

    preloadImagesOnHover() {
      this.thumbLinks.forEach((thumb) => {
        thumb.addEventListener('mouseover', () => {
          const id = thumb.getAttribute('data-media-id');
          const productImage = this.productImagesContainer.querySelector(`[data-media-id="${id}"] img`);
          productImage?.setAttribute('loading', 'eager');
        });
      });
    }

    setActiveThumb() {
      const id = this.productImagesContainer.getAttribute('data-active-media');
      const selectedThumb = this.querySelector(`[data-media-id="${id}"]`);

      // Remove class active from the previously selected thumbnail
      this.querySelector('[data-thumb-item].is-active')?.classList.remove('is-active');

      // Add class active to the selected thumbnail
      selectedThumb?.parentNode.classList.add('is-active');

      requestAnimationFrame(() => {
        this.scrollToThumb();
      });
    }

    scrollToThumb() {
      const thumbs = this.thumbSlider;

      if (thumbs) {
        const thumb = thumbs.querySelector('.is-active');
        if (!thumb) return;
        const thumbsScrollTop = thumbs.scrollTop;
        const thumbsScrollLeft = thumbs.scrollLeft;
        const thumbsWidth = thumbs.offsetWidth;
        const thumbsHeight = thumbs.offsetHeight;
        const thumbsPositionBottom = thumbsScrollTop + thumbsHeight;
        const thumbsPositionRight = thumbsScrollLeft + thumbsWidth;
        const thumbPosTop = thumb.offsetTop;
        const thumbPosLeft = thumb.offsetLeft;
        const thumbWidth = thumb.offsetWidth;
        const thumbHeight = thumb.offsetHeight;
        const thumbRightPos = thumbPosLeft + thumbWidth;
        const thumbBottomPos = thumbPosTop + thumbHeight;
        const topCheck = thumbsScrollTop > thumbPosTop;
        const bottomCheck = thumbBottomPos > thumbsPositionBottom;
        const leftCheck = thumbsScrollLeft > thumbPosLeft;
        const rightCheck = thumbRightPos > thumbsPositionRight;
        const verticalCheck = bottomCheck || topCheck;
        const horizontalCheck = rightCheck || leftCheck;
        const isMobileView = window.innerWidth < 990;

        if (verticalCheck || horizontalCheck) {
          let scrollTopPosition = thumbPosTop - thumbsHeight + thumbHeight;
          let scrollLeftPosition = thumbPosLeft - thumbsWidth + thumbWidth;

          if (topCheck) {
            scrollTopPosition = thumbPosTop;
          }

          if (rightCheck && isMobileView) {
            scrollLeftPosition += parseInt(window.getComputedStyle(thumbs).paddingRight);
          }

          if (leftCheck) {
            scrollLeftPosition = thumbPosLeft;

            if (isMobileView) {
              scrollLeftPosition -= parseInt(window.getComputedStyle(thumbs).paddingLeft);
            }
          }

          thumbs.scrollTo({
            top: scrollTopPosition,
            left: scrollLeftPosition,
            behavior: 'smooth',
          });
        }
      }
    }
  }

  // Register the custom elements
  customElements.define('alternate-product-gallery', AlternateProductGallery);
  customElements.define('alternate-product-thumbs', AlternateProductThumbs);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
